<template>
  <div class="out_box">
    <div style="width: 1480px">
      <div style="background-color: #fff; position: sticky; top: 0; left: 0; z-index: 9">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane :label="item.label" :name="item.name" v-for="item in regionArr" :key="item.name">
            <!-- <amendmentItem v-if="item.name == activeName" :ref="item.name" v-bind="item" @update="update" /> -->
          </el-tab-pane>
        </el-tabs>
      </div>

      <div v-for="item in regionArr" :key="item.name">
        <amendmentItem v-if="item.name == activeName" :ref="item.name" v-bind="item" @update="update" />
      </div>
    </div>
  </div>
</template>

<script>
import amendmentItem from './components/amendmentItem.vue'

import regionArr from './components/offer'
// console.log(regionArr)

export default {
  name: 'amendmentIndex',

  components: {
    amendmentItem
  },

  data() {
    return {
      // 日期
      date: this.$globalFun.parseTime(new Date(), '{y}-{m}-{d}'),

      lsList: [],
      zsjList: [],

      loading: true,

      activeName: 'lsList',

      regionArr: [...regionArr]
    }
  },

  async created() {
    await this.getList()
    // this.addUpdate()
  },

  mounted() {
    this.$refs[this.activeName][0].getDrafts()
  },

  methods: {
    async handleClick() {
      await this.$nextTick()
      this.$refs[this.activeName][0].init()
      this.$refs[this.activeName][0].getDrafts()
      this.$refs[this.activeName][0].setFocus()
    },

    async addUpdate() {
      const priceObj = {
        Date: '2023-11-18',
        priceStr:
          '长城(牛年生肖版) 木盒10,1210|长城(虎年生肖版) 木盒10,960|长城(兔年生肖版)(拆封) 木盒10,800|长城(兔年生肖版)(原封) 木盒10,850|长城(兔年生肖限量版)(拆封) 木盒10,1200|长城(132益川老坊) 木盒25,1350|长城(132益川老坊)云南地限 木盒25,1750|长城(10支132秘制) 木盒10,505|长城(5支传奇1号) 木盒5,195|长城(5支传奇3号) 木盒5,552|长城(2号) 纸盒5,105|长城(揽胜3号经典) 木盒10,430|长城(经典2号) 木盒5,135|长城(经典2号新版) 木盒5,160|长城(经典3号) 木盒5,105|长城(经典3号新版) 木盒10,280|长城(3号) 纸盒5,80|长城(大号铝管5支) 木盒5,100|长城(红色132) 铁盒5,78|长城(盛世3号) 纸盒10,225|长城(盛世5号) 纸盒10,125|长城(盛世6号) 纸盒30,480|长城(GL1号)(不烫码) 木盒5,3500|长城(GJ6) 木盒10,920|长城(GJ6成都限量) 木盒10,1350|长城(国礼3) 木盒10,1320|长城(国礼3)成都限量版 木盒10,1580|长城(伟大的胜利) 木盒10,1600|长城(唯佳金字塔) 木盒10,880|长城(唯佳金字塔)成都限量 木盒10,950|狮牌(加勒比阳光) 纸盒20,175|长城(骑士壹号) 纸盒20,95|长城(骑士三号) 纸盒20,280|长城(深圳40周年)盛世奇迹 木盒5,270|长城(132记忆) 纸盒25,735|长城(132奇迹) 纸盒10,405|长城(132奇迹成都限量) 纸盒10,660|长城(国之韵2号) 纸盒 纸盒,140|长城(毛氏二号) 木盒200,1650|长城(毛氏8号) 纸盒2,315|长城(毛氏13号) 木盒200,600|长城(迷你香草) 铁盒100,40|长城(迷你咖啡) 铁盒100,34|长城(迷你原味 铁盒100,31|长城(醇味132) 纸盒100,330|长城(醇雅coco) 纸盒200,110|长城(醇雅奶香) 纸盒200,105|狮牌(迷你小雪茄) 纸盒50,45|长城(迷你2号) 纸盒50,125|长城(迷你3号) 纸盒50,60|长城(金南极) 纸盒50,22|泰山(巅峰2号) 木盒10,1350|泰山(巅峰5号) 木盒10,810|泰山(巅峰6号) 纸盒5,270|将军(战神1号) 木盒10,280|将军(大力袖 纸盒5,80|将军(战神3号) 木盒10,160|将军(战神5号) 纸盒8,100|泰山(超级战神) 木盒10,830|将军(战神6H) 纸盒5,35|将军(战神07) 铁盒50,145|将军(战神荣耀) 纸盒50,265|将军(战神4号) 铁盒4,83|将军(3G) 铁盒100,40|泰山(3G咖啡) 纸盒100,55|泰山(3G水蜜桃) 纸盒100,100|泰山(3G沉香) 铁盒80,45|泰山(巴哈马) 纸盒100,43|泰山(巴哈马甜味) 铁盒100,53|泰山(黑豹) 纸盒200,110|泰山(雪豹) 纸盒200,95|泰山(雪豹中支) 纸盒200,120|泰山(丛林都市) 木盒10,970|王冠(智者010五支) 竹盒5,500|王冠(智者010十支) 竹盒10,880|王冠(大国粹) 木盒10,580|王冠(满堂彩) 木盒5,190|王冠(假日 · 阳光) 纸盒4,105|王冠(梅兰竹菊) 纸盒8,30|王冠(茶香之茶马古道) 纸盒10,445|王冠(国粹风度) 木盒10,225|王冠(古建三绝 纸盒10,300|王冠(10支全叶卷) 木盒10,350|王冠(蓝色假日) 纸盒25,390|王冠(小国粹 纸盒25,235|王冠(经典铝2支全叶卷) 纸盒10,100|王冠(塑2支全叶卷) 纸盒10,13|王冠(经典5号) 纸盒5,20|王冠(经典8号) 纸盒10,30|王冠(假日 ·黄金海岸) 纸盒12,225|王冠(赛悦) 铁盒100,65|王冠(塑) 塑盒10,12|王冠(奶香) 铁盒100,110|王冠(原味1号) 纸盒10,9|王冠(原味2号) 塑盒10,9|王冠(原味9号) 纸盒50,35|王冠(原味9号塑) 纸盒100,10|王冠(20支) 纸盒200,55|王冠(国粹名角) 纸盒100,265|王冠(粗万象) 纸盒200,135|王冠(MIX香草) 铁盒50,28|王冠(原味3号) 铁盒50,30|王冠(原味3号) 纸盒50,50|黄鹤楼(公爵) 铝盒10,2060|黄鹤楼(1916雪之梦2号) 木盒1,285|黄鹤楼(1916雪之梦3号) 木盒10,1100|黄鹤楼(雪之梦6号) 纸盒10,400|黄鹤楼(雪之梦5号) 木盒10,390|黄鹤楼(雪之梦7号) 纸盒25,870|黄鹤楼(雪之梦8号) 纸盒5,193|黄鹤楼(雪之梦9号) 纸盒25,610|黄鹤楼(雪之梦10号) 纸盒24,835|黄鹤楼(逍遥3号) 木盒10,4200|黄鹤楼(逍遥5号) 木盒10,835|黄鹤楼(逍遥6号) 木盒10,700|黄鹤楼(雪之韵2号) 硬盒20,63|黄鹤楼(雪之韵5号) 纸盒300,75|黄鹤楼(雪之韵6号) 纸盒100,235|黄鹤楼(雪之景2号) 纸盒120,115|黄鹤楼(雪之景3号) 纸盒100,145|黄鹤楼(雪之景5号) 纸盒100,160|黄鹤楼(雪之景6号) 纸盒100,470|黄鹤楼(雪之景7号) 纸盒200,230|黄鹤楼(雪之景9号) 纸盒100,305|黄鹤楼(雪之景10号) 纸盒100,215|黄鹤楼(迷你醇味) 铁盒100,145|黄鹤楼(冰爽) 纸盒100,120|茂大(1号) 纸盒20,75|工字牌(小雪茄) 纸盒200,38',
        type: '1'
      }
      console.log(priceObj.priceStr.split('|'))

      const data = await this.$api.offer.addData(priceObj)
      console.log(data)
    },

    update() {
      this.getList()
    },

    // 获取列表
    async getList() {
      const loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      const { data: res } = await this.$api.product.getList({
        pageindex: 1,
        pagesize: 10000,
        category1: '全部'
      })

      const { data: priceDifference } = await this.$api.offer.priceDifference()

      const keyObj = {
        LS: 'LSPrice',
        ZSJ: 'ZSJPrice',
        SZ: 'SZPrice',
        SZ2: 'SZPrice2',
        SZ3: 'SZPrice3',
        HN: 'HNPrice'
      }
      priceDifference.forEach((item) => {
        for (let i = 0; i < res.list.length; i++) {
          let j = 0

          if (res.list[i].Name === item.Title) {
            const type = item.Type.split('-')

            const key = keyObj[type[0]]
            const value = keyObj[type[1]]

            const differencePrice = res.list[i][value] + item.Price

            if (res.list[i].differencePrice && res.list[i].differencePrice[key]) {
              const price = res.list[i].differencePrice[key]
              res.list[i].differencePrice[key] = price > differencePrice ? differencePrice : price
            } else if (res.list[i].differencePrice) {
              res.list[i].differencePrice[key] = differencePrice
            } else {
              res.list[i].differencePrice = {}
              res.list[i].differencePrice[key] = differencePrice
            }

            j += 1
            if (j === 1) break
          }
        }
      })

      for (let i = 0; i < res.list.length; i++) {
        let price = 0
        let n = 0
        for (const key in keyObj) {
          if (res.list[i][keyObj[key]]) {
            price = this.$d.add(price, res.list[i][keyObj[key]]).toNumber()
            n++
            // console.log(res.list[i].Name, keyObj[key], res.list[i][keyObj[key]], price, n)
          }
        }
        if (n > 0) {
          res.list[i].allPrice = price
          res.list[i].n = n
        }
      }

      const allList = {}

      let priceStr = ''

      res.list.forEach((item) => {
        priceStr += `${item.Name},0,0|`

        this.regionArr.forEach((region) => {
          const order = item[region.order]
          const column = item[region.column]

          if (order && column) {
            if (!allList[region.name]) {
              allList[region.name] = []
            }

            if (!allList[region.name][column - 1]) {
              allList[region.name][column - 1] = []
            }

            allList[region.name][column - 1][order - 1] = item
          }
        })
      })
      console.log(allList)

      this.regionArr.forEach((item) => {
        item.list = []

        if (allList[item.name]) {
          allList[item.name].forEach((list) => {
            const arr = list.filter((items) => items.Id)
            item.list.push([...arr])
          })
          // item.list = [...allList[item.name]]
        }
      })

      // allList.ls2List.forEach((list) => {
      //   list.forEach((item) => {
      //     console.log(item.Name, item.Id)
      //   })
      // })

      // priceStr =
      //   '330软中华,1,1|软苏烟,1,2|合1916楼,1,3|红利群,1,4|金圣庐山,1,5|329软中华,2,1|五星苏烟,2,2|如意1916,2,3|蓝利群,2,4|金庐山,2,5|328软中华,3,1|中支五星,3,2|软1916楼,3,3|软嘴长利群,3,4|黄精庐山,3,5|2头软中华,4,1|中支彩苏烟,4,2|粗15年1916楼,4,3|合长嘴利群,4,4|更上一层楼,4,5|公司合中华,5,1|中支多彩苏烟,5,2|细15年1916楼,5,3|软阳光利群,5,4|金圣吉品,5,5|方合中华,6,1|雨花石,6,2|合1916红珠,6,3|新利群,6,4|金圣金吉,6,5|金双支中华,7,1|雨花石3mg,7,2|中支1916楼,7,3|西子利群,7,4|赣金圣,7,5|方合金中华,8,1|95京,8,2|新中支1916楼,8,3|国色利群,8,4|大红运庐山,8,5|金短支中华,9,1|软95京,9,2|软楼,9,3|中支橙利群,9,4|合白金圣,9,5|金细支中华,10,1|小95京,10,2|雅香金,10,3|小休闲利群,10,4|软白金圣,10,5|细支普中,11,1|炫赫门南京,11,2|大彩楼,11,3|西湖恋利群,11,4|合红金圣,11,5|硬5支中华,12,1|炫彩小南京,12,2|空心合红楼,12,3|夜西湖利群,12,4|合腾王阁,12,5|硬12支中华,13,1|大观园南京,13,2|软雅韵楼,13,3|楼外楼利群,13,4|腾王阁紫光,13,5|短前门,14,1|梦都小南京,14,2|合雅韵楼,14,3|新楼外楼利群,14,4|长天腾王阁,14,5|软前门,15,1|十二钗,15,2|天下名楼,15,3|休闲利群,15,4|智圣出山,15,5|333软牡丹,16,1|薄荷十二钗,16,2|合雪之景楼,16,3|二代利群,16,4|细支国味,16,5|330软牡丹,17,1|醇南京,17,2|合珍品楼,17,3|江南韵利群,17,4|方合中国红,17,5|3头软牡丹,18,1|合乌王,18,2|软珍品楼,18,3|利群金红利,18,4|中支中国红,18,5|青柠牡丹,19,1|爆珠合乌王,19,2|8度楼,19,3|中支阳光尊,19,4|新版中国红,19,5|中支乌牡丹,20,1|锦绣芙蓉王,20,2|银紫楼,20,3|阳光青利群,20,4|国瓷金圣,20,5|中支红牡丹,21,1|芙蓉王,21,2|胜景楼,21,3|细支阳光尊,21,4|金圣青瓷,21,5|细支凤凰牡丹,22,1|中支芙蓉王,22,2|中支感恩楼,22,3|大红方印,22,4|中支青瓷,22,5|盒上海喜,23,1|短黄芙蓉王,23,2|奇景楼,23,3|细支红方印,23,4|细支青瓷,23,5|8克上海双喜,24,1|细芙蓉王,24,2|久久平安楼,24,3|中支红方印,24,4|荷花,24,5|软红中南海,25,1|细蓝闪带王,25,2|中支蓝楼,25,3|金中支红方印,25,4|金荷花,25,5|牡丹飞马,26,1|细红闪带王,26,2|雪之景2号,26,3|软记忆黄山,26,4|细支荷花,26,5|方恒大牌,27,1|领航芙蓉王,27,2|雪之景3号,27,3|合记忆黄山,27,4|软荷花,27,5|中支恒大,28,1|王之荣耀,28,2|雪之景6号,28,3|新黄山,28,4|中支荷花,28,5|恒大蓝金中支,29,1|黄色荣耀中支,29,2|雪之梦1号,29,3|印象黄山,29,4|经典中支荷花,29,5|金上海双喜,30,1|蓝色荣耀细支,30,2|雪之梦2号,30,3|大黄山,30,4|青山绿水荷花,30,5|青大熊猫,31,1|软芙蓉,31,2|雪之梦3号,31,3|细支黑马,31,4|钻石玫瑰二代,31,5|大熊猫硬经典,32,1|和天下,32,2|雪之梦5号,32,3|新制皖烟,32,4|软绿钻石,32,5|5克中南海,33,1|软和天下,33,2|雪之梦6号,33,3|金皖黄山,33,4|合红钻石,33,5|中支5g中南海,34,1|细和天下,34,2|新雪之梦7号,34,3|细支微商,34,4|合蓝钻石,34,5|3g中南海,35,1|中支和天下,35,2|雪之梦8号,35,3|微风皖韵,35,4|醇和钻石,35,5|金装8g中南海,36,1|尊享和天下,36,2|雪之梦9号,36,3|紫微商,36,4|紫钻石,36,5|黑8克中南海,37,1|尊品和天下,37,2|雪之梦10号,37,3|粗微商,37,4|软红钻石,37,5|典5中南海,38,1|中支尊品和天下,38,2|黄鹤楼逍遥6号,38,3|中支金皖,38,4|玉兰钻石,38,5|中支冰耀中南海,39,1| 和气生财,39,2|峡谷柔情,39,3|中支高山流水,39,4|天叶,39,5|春天咖路里,40,1|细支和气生财,40,2|小支峡谷情,40,3|中支都宝,40,4|小天叶,40,5|新版小国喜,41,1|红宝石芙蓉王,41,2|大峡谷情,41,3|皇冠雪茄,41,4|中支天叶,41,5|金国喜,42,1|鸿运当头沙,42,2|中支峡谷情,42,3|龙凤呈祥,42,4|软天叶,42,5|中支春天,43,1|乌白沙,43,2|嘉禧缘楼,43,3|朝天门,43,4|小天香,43,5|小支春天,44,1|三代沙,44,2|视窗黄鹤楼,44,3|佳品龙凤呈祥,44,4|中支天香,44,5|魅影春天,45,1|蓝尚沙,45,2|软红金龙,45,3|细支金遇见,45,4|粗天香,45,5|春天自在,46,1|精白沙,46,2|新版合金龙,46,3|花开富贵,46,4|爱尚黄金叶,46,5|春天斐然,47,1|合白沙,47,2|和谐玉溪,47,3|畅行天下,47,4|乐途黄金叶,47,5|金花悦喜,48,1|软白沙,48,2|中支和谐玉溪,48,3|天子金,48,4|中支乐途,48,5|勿忘我,49,1|天天向上,49,2|中支境界玉溪,49,3|软兰娇子,49,4|合乐途黄金叶,49,5|新邮喜,50,1|软相思鸟,50,2|二维码合玉溪,50,3|X娇子,50,4|天尊黄金叶,50,5|黑逸品喜,51,1|软银狼,51,2|软玉溪,51,3|红时代娇,51,4|小目标,51,5|百年经典双,52,1|蓝钻狼,52,2|初心玉溪,52,3|蓝时代娇子,52,4|黄金眼,52,5|世纪经典,53,1|纯雅狼,53,2|高配玉溪,53,3|红格调娇子,53,4|商鼎叶,53,5|双喜莲香,54,1|合红狼,54,2|尚善玉溪,54,3|细格调娇子,54,4|金满堂,54,5|经典工坊,55,1|软红狼,55,2|玉溪（银鑫中支）,55,3|长城陈皮,55,4|喜满堂,55,5|盛世双喜,56,1|豪运狼,56,2|细支绿玉溪,56,3|长城奶香,56,4|金帝豪,56,5|合1906喜,57,1|合白狼,57,2|青绿叠波玉溪,57,3|中支天子,57,4|中支浓香黄金叶,57,5|软1906喜,58,1|合兰狼,58,2|软玉溪阿诗玛,58,3|天子黄中支,58,4|中支国色,58,5|合经典,59,1|豪情狼,59,2|中支阿诗玛,59,3|细逍遥宽窄,59,4|大M黄金叶,59,5|软经典,60,1|中支纯境狼,60,2|细支阿诗玛,60,3|中支宽窄逍遥,60,4|新精红旗渠,60,5|01盒双喜,61,1|中支观海狼,61,2|新时代塔,61,3|粗宽窄逍遥,61,4|新芒果,61,5|01软双喜,62,1|奶香七匹狼,62,2|传奇塔山,62,3|中支醇香宽窄,62,4|红旗渠雪茄,62,5|新盒双喜,63,1|锋芒七匹狼,63,2|细支传奇塔山,63,3|软五粮醇香,63,4|公司软红万,63,5|金01喜,64,1|中支银狼,64,2|合塔山,64,3|中支宽窄平安,64,4|公司合红万,64,5|合椰树,65,1|土楼1575,65,2|软塔山,65,3|软宽窄平安,65,4|公司合白万,65,5|黄嘴软红五叶,66,1|古田金中支,66,2|百年塔山,66,3|方合宽窄,66,4|公司软白万,66,5|红五叶,67,1|古田红金灰,67,2|新势力塔山,67,3|宽窄好运,67,4|公司爆珠万,67,5|新五叶神,68,1|真龙娇子,68,2|珍软云,68,3|细宽窄鸿运,68,4|公司蓝三五,68,5|金樽五叶神,69,1|祥云真龙,69,2|细支珍云烟,69,3|金天下秀,69,4|公白三五,69,5|欢乐颂好日子,70,1|轩云真龙,70,2|乌金刚,70,3|30年国酒,70,4|三五国际版,70,5|金樽日子,71,1|软红真龙,71,2|云烟云端,71,3|细30年国酒,71,4|细支老版三五,71,5|细金樽日子,72,1|锦绣真龙,72,2|中支云烟云端,72,3|贵烟金百合,72,4|公司七星蓝莓,72,5|软珍日,73,1|中支真龙,73,2|精云,73,3|新贵烟,73,4|公司七星晶选,73,5|祥和日子,74,1|细真龙凌云,74,2|软精云,74,3|跨越贵烟,74,4|公司七星1克,74,5|祥云日子,75,1|真龙海韵,75,2|软如意云烟,75,3|贵烟萃,75,4|公司七星4克,75,5|吉祥日,76,1|中支真龙海韵,76,2|重九,76,3|贵烟红中支,76,4|公司七星7克,76,5|精日子,77,1|细支真龙海韵,77,2|9+1重九,77,3|贵烟福中支,77,4|硬银辉,77,5|城市之光,78,1|真龙起源,78,2|中支大重九,78,3|贵烟喜贵,78,4|公司双冰555,78,5|万象好日子,79,1|合珍品真龙,79,2|小重九,79,3|贵烟老喜贵,79,4|金天越555,79,5|晶彩日子,80,1|细支刘三姐,80,2|中支青小重九,80,3|贵烟山水,80,4|公司冰炫555,80,5|锦绣日,81,1|16支兰州,81,2|软黄梅,81,3|磨砂黄果树,81,4|公司经典555,81,5|合至尊,82,1|中支黑兰州,82,2|盒红河,82,3|长征果,82,4|公司软南,82,5|软至尊,83,1|黑珍品兰州,83,2|软红河,83,3|佳品黄果树,83,4|公司6克南,83,5|精红玫,84,1|兰州硬黄,84,2|合云龙,84,3|望岳泰山,84,4|公司绿爱喜,84,5|紫红玫王,85,1|兰州硬红,85,2|小云龙,85,3|宏图泰山,85,4|公司蓝爱喜,85,5|中支迎春,86,1|如意兰州,86,2|新世猫,86,3|青秀泰山,86,4|公司爆珠爱喜,86,5|小迎春,87,1|精品兰州,87,2|家园猫,87,3|细泰山心悦,87,4|爱喜双爆倍享,87,5|软长白山,88,1|合蓝兰州,88,2|人民大会堂,88,3|细泰山颜悦,88,4|细支1号建牌,88,5|合长白山,89,1|红韵延安,89,2|细人民大会堂,89,3|细泰山合悦,89,4|公司健牌紫冰,89,5|777长白山,90,1|中支红韵延安,90,2|中支人民大会堂,90,3|细泰山茶香,90,4|公司健牌中空4,90,5|长白山参缘,91,1|软延安,91,2|中支盛京,91,3|泰山红将军,91,4|宝亨宝珠,91,5|老巴夺,92,1|金猴王,92,2|小虫草,92,3|泰山白将军,92,4|公司金阿里山,92,5|中支老巴夺,93,1|磨砂金猴王,93,2|中支虫草,93,3|中支泰山将军,93,4|景泰典蓝,93,5|传奇老巴夺,94,1|好猫招财进宝,94,2|中支红虫草,94,3|平安泰山,94,4|公司大喜,94,5|中支金丝猴,95,1|黑招财猫,95,2|细支蓝钓鱼台,95,3|华贵泰山,95,4|公爱国洋,95,5|细支好猫长乐,96,1|金丝猴,96,2|细支钓鱼台,96,3|细儒风泰山,96,4|大华黄金眼,96,5|中支九美长乐,97,1|细支三沙,97,2|中支钓鱼台,97,3|醇香哈德门,97,4|金桥单爆,97,5|软昭君,98,1|长丰大青山,98,2|翡翠,98,3|八喜泰山,98,4|中支金桥,98,5|'
      priceStr = ''
      console.log(priceStr, regionArr)
      // await this.$api.offer.updateSort({
      //   type: 2,
      //   priceStr
      // })

      loading.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.out_box {
  width: calc(100% - 20px);
  height: calc(100vh - 75px);
  padding-bottom: 20px;
  overflow: scroll;

  position: absolute;
  top: 20px;
  left: 20px;
}

.TableTop {
  display: flex;
  margin-top: 10px;

  .TableTop_tit {
    width: 200px;
  }

  .TableTop_btn {
    flex: 2;
    margin-left: 300px;
  }
}

.paixu {
  margin-top: 12px;
  display: flex;

  .paixu_btn {
    margin-left: 20px;
    margin-top: 12px;
  }
}

.divTable {
  width: 1280px;
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;

  .numIndex {
    width: 40px;

    .order {
      text-align: center;
      color: blue;
      height: 24px;
      line-height: 24px;
    }
  }

  .ulTables {
    flex: 2;
    display: flex;
    justify-content: flex-start;
  }

  .ulTable {
    width: 200px;
    height: 24px;
    line-height: 24px;
    display: flex;
    position: relative;

    .reference_price {
      height: 24px;
      padding: 0 4px;
      background-color: #efefef;
      display: none;
      position: absolute;
      top: -48px;
      left: 0;
    }

    .other_price {
      // width: 100%;
      height: 24px;
      padding: 0 4px;
      background-color: #efefef;
      display: none;
      position: absolute;
      top: -24px;
      left: 0;
    }

    li.red:hover {
      overflow: inherit;
    }

    .title {
      width: 43%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-left: 5px;
      font-size: 13px;
    }

    .price {
      width: 35%;
    }

    .red {
      width: 45%;
      color: red;
      font-weight: bold;
      font-size: 14px;
    }

    .gray {
      color: rgba(0, 0, 0, 0.4);
    }

    .red:hover {
      overflow: none;
    }
  }
}

.blue {
  color: #409eff;
  padding-bottom: 10px;
  border-bottom: 2px solid #409eff;
}
</style>
